module.exports = __webpack_public_path__ + "static/blank-d6c62ab5baca7c294cf1e8d23d7d0f2b.jpg";